import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import {
  Container,
  PageHeader,
  FilterRow,
  TableWrapper,
  AddButton,
  ModalOverlay,
  ModalContent,
  ModalTitle,
  Input,
  Select,
  ModalActions,
  ButtonCancelar,
  ButtonSalvar,
  TabsContainer,
  Tab,
  TabContent,
  FilterGroup,
  FilterLabel,
  TextArea
} from "./styles";

const mockContasBase = [
  {
    descricao: "Aluguel Loja",
    valor: 3500,
    vencimento: "2025-04-10",
    status: "pendente",
    tipo_pagamento: "fornecedor",
    fornecedor: "Imobiliária ABC",
    forma_pagamento: "Boleto",
    categoria: "Aluguel",
    numero_documento: "FAT123",
    centro_custo: "Administrativo",
    observacoes: "Pagar até às 17h."
  },
  {
    descricao: "Conta de Luz",
    valor: 980,
    vencimento: "2025-04-15",
    status: "pago",
    tipo_pagamento: "fornecedor",
    fornecedor: "Copel",
    forma_pagamento: "Débito automático",
    categoria: "Energia",
    numero_documento: "FAT456",
    centro_custo: "Operacional",
    observacoes: "",
    data_pagamento: "2025-04-14"
  },
  {
    descricao: "Salário Ana",
    valor: 2800,
    vencimento: "2025-04-05",
    status: "pendente",
    tipo_pagamento: "funcionario",
    fornecedor: "",
    forma_pagamento: "Transferência",
    categoria: "Pessoal",
    numero_documento: "FOL789",
    centro_custo: "RH",
    observacoes: "Colaboradora CLT"
  },
  {
    descricao: "Internet Escritório",
    valor: 220,
    vencimento: "2025-03-28",
    status: "vencido",
    tipo_pagamento: "fornecedor",
    fornecedor: "Vivo",
    forma_pagamento: "Pix",
    categoria: "Internet",
    numero_documento: "FAT999",
    centro_custo: "TI",
    observacoes: "Repetir mensalmente"
  },
  {
    descricao: "Materiais de Escritório",
    valor: 350,
    vencimento: "2025-04-20",
    status: "pendente",
    tipo_pagamento: "fornecedor",
    fornecedor: "Papelaria Central",
    forma_pagamento: "Cartão de Crédito",
    categoria: "Suprimentos",
    numero_documento: "NF1234",
    centro_custo: "Administrativo",
    observacoes: ""
  },
  {
    descricao: "Manutenção Equipamentos",
    valor: 1200,
    vencimento: "2025-04-18",
    status: "pendente",
    tipo_pagamento: "fornecedor",
    fornecedor: "TecMáquinas",
    forma_pagamento: "Boleto",
    categoria: "Manutenção",
    numero_documento: "OS5678",
    centro_custo: "Operacional",
    observacoes: "Serviço urgente"
  }
];

// Cores para gráficos
const COLORS = {
  pendente: "#f59e0b",
  pago: "#10b981",
  vencido: "#ef4444",
  aluguel: "#8b5cf6",
  energia: "#3b82f6",
  pessoal: "#ec4899",
  internet: "#6366f1",
  suprimentos: "#14b8a6",
  manutencao: "#f97316"
};

function getInicioMes() {
  const data = new Date();
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-01`;
}

function getFimMes() {
  const data = new Date();
  return new Date(data.getFullYear(), data.getMonth() + 1, 0).toISOString().split('T')[0];
}

export default function ContasPagar() {
  const [contas, setContas] = useState([]);

  const [tabAtiva, setTabAtiva] = useState("dados");

  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroPeriodo, setFiltroPeriodo] = useState({ de: getInicioMes(), ate: getFimMes() });
  const [resumoStatus, setResumoStatus] = useState({});
  const [resumoCategoria, setResumoCategoria] = useState([]);
  const [resumoFormaPagamento, setResumoFormaPagamento] = useState([]);
  const [resumoCentroCusto, setResumoCentroCusto] = useState([]);
  const [fluxoMensal, setFluxoMensal] = useState([]);
  const [recomendacoes, setRecomendacoes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPagamento, setModalPagamento] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({});
  const [confirmarExclusao, setConfirmarExclusao] = useState(null);
  const [marcandoComoPago, setMarcandoComoPago] = useState(null);
  const [exibirDetalhes, setExibirDetalhes] = useState(false);
  const [pesquisa, setPesquisa] = useState("");
  const [visualizacao, setVisualizacao] = useState("tabela");
  const [fornecedores, setFornecedores] = useState([]);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [centrosCusto, setCentrosCusto] = useState([]);
  const [modalContaAberto, setModalContaAberto] = useState(false);

  const fecharModal = () => {
    setModalContaAberto(false); // ou o modal correspondente
  };
    const filtrarContas = () => {
    let resultado = [...mockContasBase];

    if (filtroStatus !== "todos") {
      resultado = resultado.filter(c => c.status === filtroStatus);
    }

    if (filtroPeriodo.de) {
      resultado = resultado.filter(c => new Date(c.vencimento) >= new Date(filtroPeriodo.de));
    }

    if (filtroPeriodo.ate) {
      resultado = resultado.filter(c => new Date(c.vencimento) <= new Date(filtroPeriodo.ate));
    }

    if (pesquisa) {
      const termoLower = pesquisa.toLowerCase();
      resultado = resultado.filter(c =>
        c.descricao.toLowerCase().includes(termoLower) ||
        c.fornecedor.toLowerCase().includes(termoLower) ||
        c.categoria.toLowerCase().includes(termoLower)
      );
    }

    setContas(resultado);
    atualizarDashboard(resultado);
    setRecomendacoes(gerarRecomendacoes(resultado));
  };

  const atualizarDashboard = (lista) => {
    // Resumo por status
    const resumo = {
      pendente: lista.filter(c => c.status === "pendente").reduce((acc, c) => acc + c.valor, 0),
      pago: lista.filter(c => c.status === "pago").reduce((acc, c) => acc + c.valor, 0),
      vencido: lista.filter(c => c.status === "vencido").reduce((acc, c) => acc + c.valor, 0)
    };
    setResumoStatus(resumo);

    // Dados para gráfico de pizza - por categoria
    const categorias = {};
    lista.forEach(c => {
      if (!categorias[c.categoria]) categorias[c.categoria] = 0;
      categorias[c.categoria] += c.valor;
    });
    const resumoCat = Object.keys(categorias).map(cat => ({
      name: cat,
      value: categorias[cat]
    }));
    setResumoCategoria(resumoCat);

    // Dados para gráfico de barras - formas de pagamento
    const formas = {};
    lista.forEach(c => {
      if (!formas[c.forma_pagamento]) formas[c.forma_pagamento] = 0;
      formas[c.forma_pagamento] += c.valor;
    });
    const resumoFormas = Object.keys(formas).map(forma => ({
      name: forma,
      value: formas[forma]
    }));
    setResumoFormaPagamento(resumoFormas);

    // Dados para gráfico de barras - centro de custo
    const centros = {};
    lista.forEach(c => {
      if (!centros[c.centro_custo]) centros[c.centro_custo] = 0;
      centros[c.centro_custo] += c.valor;
    });
    const resumoCentros = Object.keys(centros).map(centro => ({
      name: centro,
      value: centros[centro]
    }));
    setResumoCentroCusto(resumoCentros);

    // Dados para fluxo mensal
    const meses = {};
    lista.forEach(c => {
      const mesAno = c.vencimento.substring(0, 7);
      if (!meses[mesAno]) meses[mesAno] = { pendente: 0, pago: 0, vencido: 0 };
      meses[mesAno][c.status] += c.valor;
    });
    const fluxo = Object.keys(meses).sort().map(mesAno => ({
      name: formatarMesAno(mesAno),
      pendente: meses[mesAno].pendente,
      pago: meses[mesAno].pago,
      vencido: meses[mesAno].vencido
    }));
    setFluxoMensal(fluxo);

    // Extrair listas de fornecedores, categorias, etc.
    const fornecedoresUnicos = [...new Set(lista.filter(c => c.fornecedor).map(c => c.fornecedor))];
    const categoriasUnicas = [...new Set(lista.map(c => c.categoria))];
    const formasPagamentoUnicas = [...new Set(lista.map(c => c.forma_pagamento))];
    const centrosCustoUnicos = [...new Set(lista.map(c => c.centro_custo))];

    setFornecedores(fornecedoresUnicos);
    setCategorias(categoriasUnicas);
    setFormasPagamento(formasPagamentoUnicas);
    setCentrosCusto(centrosCustoUnicos);
  };

  const formatarMesAno = (mesAno) => {
    const [ano, mes] = mesAno.split('-');
    const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return `${meses[parseInt(mes) - 1]}/${ano}`;
  };

  const gerarRecomendacoes = (lista) => {
    const hoje = new Date();
    const proximas = lista.filter(c => c.status === 'pendente' && new Date(c.vencimento) <= new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 2));
    const recorrentes = lista.filter(c => c.observacoes.toLowerCase().includes('repetir'));
    const dicas = [];

    if (lista.some(c => c.status === 'vencido')) {
      dicas.push("🔴 Você tem contas vencidas. Priorize o pagamento o quanto antes.");
    }

    if (proximas.length > 0) {
      dicas.push(`🟡 Você tem ${proximas.length} contas pendentes com vencimento nos próximos 2 dias.`);
    }

    if (recorrentes.length > 0) {
      dicas.push(`🔁 Deseja repetir o pagamento de '${recorrentes[0].descricao}' para o próximo mês?`);
    }

    // Novas recomendações baseadas em análise
    const totalPendente = lista.filter(c => c.status === 'pendente').reduce((acc, c) => acc + c.valor, 0);
    const categoriaMaisCara = [...resumoCategoria].sort((a, b) => b.value - a.value)[0];

    if (categoriaMaisCara && categoriaMaisCara.value > totalPendente * 0.4) {
      dicas.push(`📊 A categoria '${categoriaMaisCara.name}' representa mais de 40% dos seus gastos. Considere revisar este orçamento.`);
    }

    // Análise de fluxo de caixa
    const totalPendenteProximos7Dias = lista.filter(c =>
      c.status === 'pendente' &&
      (new Date(c.vencimento) <= new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 7))
    ).reduce((acc, c) => acc + c.valor, 0);

    if (totalPendenteProximos7Dias > totalPendente * 0.7) {
      dicas.push(`💰 Alerta de fluxo de caixa! Mais de 70% dos seus pagamentos vencem nos próximos 7 dias.`);
    }

    return dicas;
  };

  useEffect(() => {
    filtrarContas();
  }, []);

  const abrirModal = (conta = null) => {
    setEditando(conta);
    setForm(conta || {
      descricao: "",
      valor: 0,
      vencimento: "",
      status: "pendente",
      tipo_pagamento: "fornecedor",
      fornecedor: "",
      forma_pagamento: "",
      categoria: "",
      numero_documento: Date.now().toString(),
      centro_custo: "",
      observacoes: "",
      data_pagamento: "",
      anexos: [],
      competencia: "",
      conciliado: "Não conciliado",
      tags: [],
      repetir_mensalmente: false
    });
    setModalOpen(true);
  };

  const salvarConta = () => {
    if (editando) {
      const atualizadas = contas.map(c => c.numero_documento === editando.numero_documento ? form : c);
      setContas(atualizadas);
      atualizarDashboard(atualizadas);
    } else {
      const novasContas = [...contas, form];
      setContas(novasContas);
      atualizarDashboard(novasContas);
    }
    setModalOpen(false);
  };

  const abrirModalPagamento = (conta) => {
    setMarcandoComoPago(conta);
    setForm({ ...conta, data_pagamento: new Date().toISOString().split("T")[0] });
    setModalPagamento(true);
  };

  const salvarPagamento = () => {
    const atualizadas = contas.map(c =>
      c.numero_documento === marcandoComoPago.numero_documento
        ? { ...c, status: "pago", data_pagamento: form.data_pagamento }
        : c
    );
    setContas(atualizadas);
    atualizarDashboard(atualizadas);
    setMarcandoComoPago(null);
    setModalPagamento(false);
  };

  const excluirConta = () => {
    const atualizadas = contas.filter(c => c.numero_documento !== confirmarExclusao.numero_documento);
    setContas(atualizadas);
    atualizarDashboard(atualizadas);
    setConfirmarExclusao(null);
  };

  const formatarData = (data) => {
    if (!data) return "-";
    const partes = data.split("T")[0].split("-");
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const calcularProximosVencimentos = () => {
    const hoje = new Date();
    return contas
      .filter(c => c.status === 'pendente')
      .sort((a, b) => new Date(a.vencimento) - new Date(b.vencimento))
      .slice(0, 5);
  };

  const abrirDetalhesConta = (conta) => {
    setContaSelecionada(conta);
  };

  const marcarTodasVencidasComoPagas = () => {
    const contasVencidas = contas.filter(c => c.status === 'vencido');
    if (contasVencidas.length === 0) return;

    const hoje = new Date().toISOString().split('T')[0];
    const atualizadas = contas.map(c =>
      c.status === 'vencido' ? { ...c, status: 'pago', data_pagamento: hoje } : c
    );

    setContas(atualizadas);
    atualizarDashboard(atualizadas);
  };

  const exportarCSV = () => {
    const headers = [
      'Descrição', 'Valor', 'Vencimento', 'Status', 'Data Pagamento',
      'Tipo', 'Fornecedor', 'Forma', 'Categoria', 'Documento', 'Centro Custo', 'Observações'
    ];

    let csvContent = headers.join(',') + '\n';

    contas.forEach(conta => {
      const row = [
        `"${conta.descricao}"`,
        conta.valor,
        conta.vencimento,
        conta.status,
        conta.data_pagamento || '',
        conta.tipo_pagamento,
        `"${conta.fornecedor || ''}"`,
        `"${conta.forma_pagamento || ''}"`,
        `"${conta.categoria || ''}"`,
        `"${conta.numero_documento || ''}"`,
        `"${conta.centro_custo || ''}"`,
        `"${conta.observacoes || ''}"`
      ];
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `contas_a_pagar_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container>
      <Header />
      <div style={{ textAlign: 'center', marginBottom: '24px', marginTop: '64px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: '600' }}>Contas a Pagar</h1>
        <p style={{ fontSize: '16px', color: '#666' }}>Finanças claras, decisões certeiras.</p>
      </div>

      {/* Resumo em Cards */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '200px', textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#ef4444', fontWeight: '600' }}>🔴 Vencido</div>
          <div style={{ fontSize: '24px', fontWeight: '700', marginTop: '8px' }}>
            {formatarMoeda(resumoStatus.vencido || 0)}
          </div>
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '200px', textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#f59e0b', fontWeight: '600' }}>🟡 Pendente</div>
          <div style={{ fontSize: '24px', fontWeight: '700', marginTop: '8px' }}>
            {formatarMoeda(resumoStatus.pendente || 0)}
          </div>
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '200px', textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#10b981', fontWeight: '600' }}>🟢 Pago</div>
          <div style={{ fontSize: '24px', fontWeight: '700', marginTop: '8px' }}>
            {formatarMoeda(resumoStatus.pago || 0)}
          </div>
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '200px', textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#6366f1', fontWeight: '600' }}>💰 Total</div>
          <div style={{ fontSize: '24px', fontWeight: '700', marginTop: '8px' }}>
            {formatarMoeda((resumoStatus.pendente || 0) + (resumoStatus.pago || 0) + (resumoStatus.vencido || 0))}
          </div>
        </div>
      </div>

      {/* Barra de filtros */}
      <FilterRow style={{ justifyContent: 'center', flexWrap: 'wrap', gap: '15px', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <label>
            Status:
            <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
              <option value="todos">Todos</option>
              <option value="pendente">Pendente</option>
              <option value="pago">Pago</option>
              <option value="vencido">Vencido</option>
            </select>
          </label>
          <label>
            De:
            <input type="date" value={filtroPeriodo.de} onChange={(e) => setFiltroPeriodo({ ...filtroPeriodo, de: e.target.value })} />
          </label>
          <label>
            Até:
            <input type="date" value={filtroPeriodo.ate} onChange={(e) => setFiltroPeriodo({ ...filtroPeriodo, ate: e.target.value })} />
          </label>
          <input
            type="text"
            placeholder="Pesquisar..."
            value={pesquisa}
            onChange={(e) => setPesquisa(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ccc' }}
          />
          <button
            onClick={filtrarContas}
            style={{ backgroundColor: '#2563eb', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
          >
            🔍 Pesquisar
          </button>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => setVisualizacao("tabela")}
            style={{
              backgroundColor: visualizacao === "tabela" ? '#2563eb' : '#e5e7eb',
              color: visualizacao === "tabela" ? 'white' : '#374151',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            📋 Tabela
          </button>
          <button
            onClick={() => setVisualizacao("dashboard")}
            style={{
              backgroundColor: visualizacao === "dashboard" ? '#2563eb' : '#e5e7eb',
              color: visualizacao === "dashboard" ? 'white' : '#374151',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            📊 Dashboard
          </button>
        </div>
      </FilterRow>

      {/* Recomendações */}
      {recomendacoes.length > 0 && (
        <div style={{ backgroundColor: '#fef3c7', padding: '20px', borderRadius: '10px', margin: '20px auto', maxWidth: '900px' }}>
          <h3 style={{ marginBottom: '10px', color: '#92400e' }}>📌 Recomendações:</h3>
          <ul style={{ margin: 0, paddingLeft: '20px', color: '#92400e' }}>
            {recomendacoes.map((rec, i) => (
              <li key={i}>{rec}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Painel de Ações Rápidas */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', margin: '20px 0' }}>
        <AddButton onClick={() => abrirModal()}>➕ Nova Conta</AddButton>
        <button
          onClick={exportarCSV}
          style={{
            backgroundColor: '#15803d',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          📊 Exportar CSV
        </button>
        <button
          onClick={marcarTodasVencidasComoPagas}
          style={{
            backgroundColor: '#0284c7',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          ✓ Marcar Vencidas como Pagas
        </button>
      </div>

      {/* Próximos vencimentos (Sempre visível) */}
      <div style={{ margin: '30px auto', maxWidth: '900px', backgroundColor: '#f8fafc', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        <h3 style={{ marginBottom: '15px', color: '#334155', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>
          ⏰ Próximos Vencimentos
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {calcularProximosVencimentos().map((conta, idx) => (
            <div key={idx} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              borderLeft: `4px solid ${new Date(conta.vencimento) < new Date() ? '#ef4444' : '#f59e0b'}`
            }}>
              <div>
                <div style={{ fontWeight: '500' }}>{conta.descricao}</div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>{conta.fornecedor}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div>
                  <div style={{ textAlign: 'right', fontWeight: '500' }}>{formatarMoeda(conta.valor)}</div>
                  <div style={{ fontSize: '14px', color: '#64748b' }}>{formatarData(conta.vencimento)}</div>
                </div>
                <button
                  onClick={() => abrirModalPagamento(conta)}
                  style={{ backgroundColor: '#10b981', color: 'white', padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer' }}
                >
                  Pagar
                </button>
              </div>
            </div>
          ))}
          {calcularProximosVencimentos().length === 0 && (
            <div style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
              Nenhuma conta pendente para os próximos dias. 🎉
            </div>
          )}
        </div>
      </div>

      /* Visualização: Dashboard */
      {visualizacao === "dashboard" && (
        <div style={{ margin: '30px auto', maxWidth: '1200px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))', gap: '20px' }}>
            {/* Gráfico de Pizza - Status */}
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h3 style={{ marginBottom: '15px', color: '#334155' }}>Status das Contas</h3>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={[
                      { name: 'Pendente', value: resumoStatus.pendente || 0 },
                      { name: 'Pago', value: resumoStatus.pago || 0 },
                      { name: 'Vencido', value: resumoStatus.vencido || 0 }
                    ]}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  >
                    <Cell key="pendente" fill={COLORS.pendente} />
                    <Cell key="pago" fill={COLORS.pago} />
                    <Cell key="vencido" fill={COLORS.vencido} />
                  </Pie>
                  <Tooltip formatter={(value) => formatarMoeda(value)} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Gráfico de Pizza - Categorias */}
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h3 style={{ marginBottom: '15px', color: '#334155' }}>Distribuição por Categoria</h3>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={resumoCategoria}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  >
                    {resumoCategoria.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[entry.name.toLowerCase()] || `#${Math.floor(Math.random() * 16777215).toString(16)}`}
                      />
                    ))}
                  </Pie>
                  <Tooltip formatter={(value) => formatarMoeda(value)} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Gráfico de Barras - Formas de Pagamento */}
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h3 style={{ marginBottom: '15px', color: '#334155' }}>Formas de Pagamento</h3>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={resumoFormaPagamento}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip formatter={(value) => formatarMoeda(value)} />
                  <Legend />
                  <Bar dataKey="value" name="Valor" fill="#3b82f6" />
                </BarChart>
              </ResponsiveContainer>
            </div>

            {/* Gráfico de Barras - Centro de Custo */}
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h3 style={{ marginBottom: '15px', color: '#334155' }}>Centro de Custo</h3>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={resumoCentroCusto}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip formatter={(value) => formatarMoeda(value)} />
                  <Legend />
                  <Bar dataKey="value" name="Valor" fill="#8b5cf6" />
                </BarChart>
              </ResponsiveContainer>
            </div>

            {/* Gráfico de Barras Empilhadas - Fluxo Mensal */}
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', gridColumn: '1 / -1' }}>
              <h3 style={{ marginBottom: '15px', color: '#334155' }}>Fluxo Mensal</h3>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={fluxoMensal}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip formatter={(value) => formatarMoeda(value)} />
                  <Legend />
                  <Bar dataKey="pendente" name="Pendente" stackId="a" fill={COLORS.pendente} />
                  <Bar dataKey="pago" name="Pago" stackId="a" fill={COLORS.pago} />
                  <Bar dataKey="vencido" name="Vencido" stackId="a" fill={COLORS.vencido} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      )}

      {/* Visualização: Tabela */}
      {visualizacao === "tabela" && (
        <TableWrapper>
          <table>
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Status</th>
                <th>Fornecedor</th>
                <th>Categoria</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {contas.map((conta) => (
                <tr key={conta.numero_documento}>
                  <td>{conta.descricao}</td>
                  <td>{formatarMoeda(conta.valor)}</td>
                  <td>{formatarData(conta.vencimento)}</td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: '600',
                      backgroundColor: conta.status === 'pendente' ? '#fef3c7' :
                        conta.status === 'pago' ? '#d1fae5' : '#fee2e2',
                      color: conta.status === 'pendente' ? '#92400e' :
                        conta.status === 'pago' ? '#065f46' : '#b91c1c'
                    }}>
                      {conta.status.toUpperCase()}
                    </span>
                  </td>
                  <td>{conta.fornecedor || '-'}</td>
                  <td>{conta.categoria}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {conta.status !== 'pago' && (
                        <button
                          onClick={() => abrirModalPagamento(conta)}
                          style={{ background: '#10b981', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer' }}
                        >
                          Pagar
                        </button>
                      )}
                      <button
                        onClick={() => abrirModal(conta)}
                        style={{ background: '#3b82f6', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer' }}
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => setConfirmarExclusao(conta)}
                        style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer' }}
                      >
                        Excluir
                      </button>
                      <button
                        onClick={() => abrirDetalhesConta(conta)}
                        style={{ background: '#6366f1', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer' }}
                      >
                        Detalhes
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {contas.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                    Nenhuma conta encontrada com os filtros selecionados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </TableWrapper>
      )}

      {/* Modal: Nova Conta / Editar Conta */}
      {modalOpen && (
        
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Conta a Pagar" : "Nova Conta a Pagar"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
      <Tab active={tabAtiva === "colaborador"} onClick={() => setTabAtiva("colaborador")}>Colaborador</Tab>
      <Tab active={tabAtiva === "imposto"} onClick={() => setTabAtiva("imposto")}>Imposto</Tab>
      <Tab active={tabAtiva === "fornecedor"} onClick={() => setTabAtiva("fornecedor")}>Fornecedor</Tab>

    </TabsContainer>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        
<FilterGroup>
  <FilterLabel>Tipo de Entidade:</FilterLabel>
  <Select value={form.tipo_entidade || "fornecedor"} onChange={(e) => setForm({ ...form, tipo_entidade: e.target.value })}>
    <option value="fornecedor">Fornecedor</option>
    <option value="colaborador">Colaborador</option>
    <option value="imposto">Imposto</option>
  </Select>
</FilterGroup>


      <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Pagamento:</FilterLabel>
        <Input type="date" value={form.data_pagamento || ""} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="pago">Pago</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Pagamento:</FilterLabel>
        <Input value={form.forma_pagamento || ""} onChange={(e) => setForm({ ...form, forma_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Multa:</FilterLabel>
        <Input type="number" value={form.multa || ""} onChange={(e) => setForm({ ...form, multa: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "fornecedor"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.fornecedor_nome || ""} onChange={(e) => setForm({ ...form, fornecedor_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.fornecedor_cnpj || ""} onChange={(e) => setForm({ ...form, fornecedor_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.fornecedor_telefone || ""} onChange={(e) => setForm({ ...form, fornecedor_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.fornecedor_email || ""} onChange={(e) => setForm({ ...form, fornecedor_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Banco:</FilterLabel>
    <Input value={form.fornecedor_banco || ""} onChange={(e) => setForm({ ...form, fornecedor_banco: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Agência:</FilterLabel>
    <Input value={form.fornecedor_agencia || ""} onChange={(e) => setForm({ ...form, fornecedor_agencia: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Conta:</FilterLabel>
    <Input value={form.fornecedor_conta || ""} onChange={(e) => setForm({ ...form, fornecedor_conta: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Chave Pix:</FilterLabel>
    <Input value={form.fornecedor_pix || ""} onChange={(e) => setForm({ ...form, fornecedor_pix: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.fornecedor_tipo || "pj"} onChange={(e) => setForm({ ...form, fornecedor_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "colaborador"}>
  <FilterGroup>
    <FilterLabel>Nome do Colaborador:</FilterLabel>
    <Input value={form.colaborador_nome || ""} onChange={(e) => setForm({ ...form, colaborador_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF:</FilterLabel>
    <Input value={form.colaborador_cpf || ""} onChange={(e) => setForm({ ...form, colaborador_cpf: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo de Pagamento:</FilterLabel>
    <Select value={form.tipo_pagamento_colaborador || "salario"} onChange={(e) => setForm({ ...form, tipo_pagamento_colaborador: e.target.value })}>
      <option value="salario">Salário</option>
      <option value="comissao">Comissão</option>
      <option value="reembolso">Reembolso</option>
    </Select>
  </FilterGroup>
</TabContent>


<TabContent visible={tabAtiva === "imposto"}>
  <FilterGroup>
    <FilterLabel>Tipo de Imposto:</FilterLabel>
    <Select value={form.tipo_imposto || "fgts"} onChange={(e) => setForm({ ...form, tipo_imposto: e.target.value })}>
      <option value="fgts">FGTS</option>
      <option value="das">DAS</option>
      <option value="irpj">IRPJ</option>
      <option value="outro">Outro</option>
    </Select>
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Competência (Mês/Ano):</FilterLabel>
    <Input value={form.competencia || ""} onChange={(e) => setForm({ ...form, competencia: e.target.value })} placeholder="MM/AAAA" />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Código de Referência:</FilterLabel>
    <Input value={form.cod_referencia || ""} onChange={(e) => setForm({ ...form, cod_referencia: e.target.value })} />
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarConta}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

      )}

      {/* Modal: Marcar como Pago */}
      {modalPagamento && (
        
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Conta a Pagar" : "Nova Conta a Pagar"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "colaborador"} onClick={() => setTabAtiva("colaborador")}>Colaborador</Tab>
<Tab active={tabAtiva === "imposto"} onClick={() => setTabAtiva("imposto")}>Imposto</Tab>
<Tab active={tabAtiva === "fornecedor"} onClick={() => setTabAtiva("fornecedor")}>Fornecedor</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        
<FilterGroup>
  <FilterLabel>Tipo de Entidade:</FilterLabel>
  <Select value={form.tipo_entidade || "fornecedor"} onChange={(e) => setForm({ ...form, tipo_entidade: e.target.value })}>
    <option value="fornecedor">Fornecedor</option>
    <option value="colaborador">Colaborador</option>
    <option value="imposto">Imposto</option>
  </Select>
</FilterGroup>


      <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Pagamento:</FilterLabel>
        <Input type="date" value={form.data_pagamento || ""} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="pago">Pago</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Pagamento:</FilterLabel>
        <Input value={form.forma_pagamento || ""} onChange={(e) => setForm({ ...form, forma_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Multa:</FilterLabel>
        <Input type="number" value={form.multa || ""} onChange={(e) => setForm({ ...form, multa: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "fornecedor"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.fornecedor_nome || ""} onChange={(e) => setForm({ ...form, fornecedor_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.fornecedor_cnpj || ""} onChange={(e) => setForm({ ...form, fornecedor_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.fornecedor_telefone || ""} onChange={(e) => setForm({ ...form, fornecedor_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.fornecedor_email || ""} onChange={(e) => setForm({ ...form, fornecedor_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Banco:</FilterLabel>
    <Input value={form.fornecedor_banco || ""} onChange={(e) => setForm({ ...form, fornecedor_banco: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Agência:</FilterLabel>
    <Input value={form.fornecedor_agencia || ""} onChange={(e) => setForm({ ...form, fornecedor_agencia: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Conta:</FilterLabel>
    <Input value={form.fornecedor_conta || ""} onChange={(e) => setForm({ ...form, fornecedor_conta: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Chave Pix:</FilterLabel>
    <Input value={form.fornecedor_pix || ""} onChange={(e) => setForm({ ...form, fornecedor_pix: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.fornecedor_tipo || "pj"} onChange={(e) => setForm({ ...form, fornecedor_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "colaborador"}>
  <FilterGroup>
    <FilterLabel>Nome do Colaborador:</FilterLabel>
    <Input value={form.colaborador_nome || ""} onChange={(e) => setForm({ ...form, colaborador_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF:</FilterLabel>
    <Input value={form.colaborador_cpf || ""} onChange={(e) => setForm({ ...form, colaborador_cpf: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo de Pagamento:</FilterLabel>
    <Select value={form.tipo_pagamento_colaborador || "salario"} onChange={(e) => setForm({ ...form, tipo_pagamento_colaborador: e.target.value })}>
      <option value="salario">Salário</option>
      <option value="comissao">Comissão</option>
      <option value="reembolso">Reembolso</option>
    </Select>
  </FilterGroup>
</TabContent>


<TabContent visible={tabAtiva === "imposto"}>
  <FilterGroup>
    <FilterLabel>Tipo de Imposto:</FilterLabel>
    <Select value={form.tipo_imposto || "fgts"} onChange={(e) => setForm({ ...form, tipo_imposto: e.target.value })}>
      <option value="fgts">FGTS</option>
      <option value="das">DAS</option>
      <option value="irpj">IRPJ</option>
      <option value="outro">Outro</option>
    </Select>
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Competência (Mês/Ano):</FilterLabel>
    <Input value={form.competencia || ""} onChange={(e) => setForm({ ...form, competencia: e.target.value })} placeholder="MM/AAAA" />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Código de Referência:</FilterLabel>
    <Input value={form.cod_referencia || ""} onChange={(e) => setForm({ ...form, cod_referencia: e.target.value })} />
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarConta}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

      )}

      {/* Modal: Confirmar Exclusão */}
      {confirmarExclusao && (
        
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Conta a Pagar" : "Nova Conta a Pagar"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "colaborador"} onClick={() => setTabAtiva("colaborador")}>Colaborador</Tab>
<Tab active={tabAtiva === "imposto"} onClick={() => setTabAtiva("imposto")}>Imposto</Tab>
<Tab active={tabAtiva === "fornecedor"} onClick={() => setTabAtiva("fornecedor")}>Fornecedor</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        
<FilterGroup>
  <FilterLabel>Tipo de Entidade:</FilterLabel>
  <Select value={form.tipo_entidade || "fornecedor"} onChange={(e) => setForm({ ...form, tipo_entidade: e.target.value })}>
    <option value="fornecedor">Fornecedor</option>
    <option value="colaborador">Colaborador</option>
    <option value="imposto">Imposto</option>
  </Select>
</FilterGroup>


      <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Pagamento:</FilterLabel>
        <Input type="date" value={form.data_pagamento || ""} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="pago">Pago</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Pagamento:</FilterLabel>
        <Input value={form.forma_pagamento || ""} onChange={(e) => setForm({ ...form, forma_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Multa:</FilterLabel>
        <Input type="number" value={form.multa || ""} onChange={(e) => setForm({ ...form, multa: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "fornecedor"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.fornecedor_nome || ""} onChange={(e) => setForm({ ...form, fornecedor_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.fornecedor_cnpj || ""} onChange={(e) => setForm({ ...form, fornecedor_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.fornecedor_telefone || ""} onChange={(e) => setForm({ ...form, fornecedor_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.fornecedor_email || ""} onChange={(e) => setForm({ ...form, fornecedor_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Banco:</FilterLabel>
    <Input value={form.fornecedor_banco || ""} onChange={(e) => setForm({ ...form, fornecedor_banco: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Agência:</FilterLabel>
    <Input value={form.fornecedor_agencia || ""} onChange={(e) => setForm({ ...form, fornecedor_agencia: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Conta:</FilterLabel>
    <Input value={form.fornecedor_conta || ""} onChange={(e) => setForm({ ...form, fornecedor_conta: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Chave Pix:</FilterLabel>
    <Input value={form.fornecedor_pix || ""} onChange={(e) => setForm({ ...form, fornecedor_pix: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.fornecedor_tipo || "pj"} onChange={(e) => setForm({ ...form, fornecedor_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "colaborador"}>
  <FilterGroup>
    <FilterLabel>Nome do Colaborador:</FilterLabel>
    <Input value={form.colaborador_nome || ""} onChange={(e) => setForm({ ...form, colaborador_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF:</FilterLabel>
    <Input value={form.colaborador_cpf || ""} onChange={(e) => setForm({ ...form, colaborador_cpf: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo de Pagamento:</FilterLabel>
    <Select value={form.tipo_pagamento_colaborador || "salario"} onChange={(e) => setForm({ ...form, tipo_pagamento_colaborador: e.target.value })}>
      <option value="salario">Salário</option>
      <option value="comissao">Comissão</option>
      <option value="reembolso">Reembolso</option>
    </Select>
  </FilterGroup>
</TabContent>


<TabContent visible={tabAtiva === "imposto"}>
  <FilterGroup>
    <FilterLabel>Tipo de Imposto:</FilterLabel>
    <Select value={form.tipo_imposto || "fgts"} onChange={(e) => setForm({ ...form, tipo_imposto: e.target.value })}>
      <option value="fgts">FGTS</option>
      <option value="das">DAS</option>
      <option value="irpj">IRPJ</option>
      <option value="outro">Outro</option>
    </Select>
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Competência (Mês/Ano):</FilterLabel>
    <Input value={form.competencia || ""} onChange={(e) => setForm({ ...form, competencia: e.target.value })} placeholder="MM/AAAA" />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Código de Referência:</FilterLabel>
    <Input value={form.cod_referencia || ""} onChange={(e) => setForm({ ...form, cod_referencia: e.target.value })} />
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarConta}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

      )}

      {/* Modal: Detalhes da Conta */}
      {contaSelecionada && (
        
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Conta a Pagar" : "Nova Conta a Pagar"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "colaborador"} onClick={() => setTabAtiva("colaborador")}>Colaborador</Tab>
<Tab active={tabAtiva === "imposto"} onClick={() => setTabAtiva("imposto")}>Imposto</Tab>
<Tab active={tabAtiva === "fornecedor"} onClick={() => setTabAtiva("fornecedor")}>Fornecedor</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        
<FilterGroup>
  <FilterLabel>Tipo de Entidade:</FilterLabel>
  <Select value={form.tipo_entidade || "fornecedor"} onChange={(e) => setForm({ ...form, tipo_entidade: e.target.value })}>
    <option value="fornecedor">Fornecedor</option>
    <option value="colaborador">Colaborador</option>
    <option value="imposto">Imposto</option>
  </Select>
</FilterGroup>


      <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Pagamento:</FilterLabel>
        <Input type="date" value={form.data_pagamento || ""} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="pago">Pago</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Pagamento:</FilterLabel>
        <Input value={form.forma_pagamento || ""} onChange={(e) => setForm({ ...form, forma_pagamento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Multa:</FilterLabel>
        <Input type="number" value={form.multa || ""} onChange={(e) => setForm({ ...form, multa: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "fornecedor"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.fornecedor_nome || ""} onChange={(e) => setForm({ ...form, fornecedor_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.fornecedor_cnpj || ""} onChange={(e) => setForm({ ...form, fornecedor_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.fornecedor_telefone || ""} onChange={(e) => setForm({ ...form, fornecedor_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.fornecedor_email || ""} onChange={(e) => setForm({ ...form, fornecedor_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Banco:</FilterLabel>
    <Input value={form.fornecedor_banco || ""} onChange={(e) => setForm({ ...form, fornecedor_banco: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Agência:</FilterLabel>
    <Input value={form.fornecedor_agencia || ""} onChange={(e) => setForm({ ...form, fornecedor_agencia: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Conta:</FilterLabel>
    <Input value={form.fornecedor_conta || ""} onChange={(e) => setForm({ ...form, fornecedor_conta: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Chave Pix:</FilterLabel>
    <Input value={form.fornecedor_pix || ""} onChange={(e) => setForm({ ...form, fornecedor_pix: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.fornecedor_tipo || "pj"} onChange={(e) => setForm({ ...form, fornecedor_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "colaborador"}>
  <FilterGroup>
    <FilterLabel>Nome do Colaborador:</FilterLabel>
    <Input value={form.colaborador_nome || ""} onChange={(e) => setForm({ ...form, colaborador_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF:</FilterLabel>
    <Input value={form.colaborador_cpf || ""} onChange={(e) => setForm({ ...form, colaborador_cpf: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo de Pagamento:</FilterLabel>
    <Select value={form.tipo_pagamento_colaborador || "salario"} onChange={(e) => setForm({ ...form, tipo_pagamento_colaborador: e.target.value })}>
      <option value="salario">Salário</option>
      <option value="comissao">Comissão</option>
      <option value="reembolso">Reembolso</option>
    </Select>
  </FilterGroup>
</TabContent>


<TabContent visible={tabAtiva === "imposto"}>
  <FilterGroup>
    <FilterLabel>Tipo de Imposto:</FilterLabel>
    <Select value={form.tipo_imposto || "fgts"} onChange={(e) => setForm({ ...form, tipo_imposto: e.target.value })}>
      <option value="fgts">FGTS</option>
      <option value="das">DAS</option>
      <option value="irpj">IRPJ</option>
      <option value="outro">Outro</option>
    </Select>
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Competência (Mês/Ano):</FilterLabel>
    <Input value={form.competencia || ""} onChange={(e) => setForm({ ...form, competencia: e.target.value })} placeholder="MM/AAAA" />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Código de Referência:</FilterLabel>
    <Input value={form.cod_referencia || ""} onChange={(e) => setForm({ ...form, cod_referencia: e.target.value })} />
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarConta}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

      )}

      <Footer />
    </Container>
  );
}